// Toque háptico corto ("tic"), como el de las apps nativas al cambiar de
// pestaña. Tiene que llamarse dentro de un toque del usuario.
// - Android (Chrome): Vibration API.
// - iPhone: Safari no tiene Vibration API, pero desde iOS 18 al cambiar un
//   <input type="checkbox" switch> el sistema da un tic; se usa uno escondido
//   y desechable. En iOS más viejos no hace nada.
export function vibrar() {
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
      navigator.vibrate(10);
      return;
    }
    const label = document.createElement('label');
    label.ariaHidden = 'true';
    label.style.display = 'none';
    const input = document.createElement('input');
    input.type = 'checkbox';
    input.setAttribute('switch', '');
    label.appendChild(input);
    document.head.appendChild(label);
    label.click();
    label.remove();
  } catch {
    // Sin soporte: no pasa nada.
  }
}
